interface ReadOnlyProps {
  isReadOnly?: boolean;
}

export const useReadOnlyParams = ({ isReadOnly }: ReadOnlyProps) => {
  return isReadOnly ? { disabled: true, variant: "filled" } : {};
};
